export * from './boolean/is-boolean.js';
